import React, { useEffect, useState } from "react";
import { ObtieneParametros, TratamientoDeVariableBoolean } from "neftis7_apicaller/src/funciones/Varios";
import { CheckBox, DateBox, TextBox } from "devextreme-react";
import ComboAbmConMonedas from "../Compuestos/Combos/ComboAbmConMonedas";
import ComboVenListaPreciosCabecera from "../Compuestos/Combos/ComboVenListaPreciosCabecera";
import LVButtonAccion from "../Basicos/LVButtonAccion";

const COM_ListasPrecios = (props) => {

  const [loading, setLoading] = useState(true);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [codigoListaPrecios, setCodigoListaPrecios] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [codigoMoneda, setCodigoMoneda] = useState("");
  const [codigoMonedaReferente, setCodigoMonedaReferente] = useState("");
  const [cotizacion, setCotizacion] = useState(0);
  const [fechaDesde, setFechaDesde] = useState(new Date());
  const [fechaHasta, setFechaHasta] = useState(new Date());
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState(false);
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState(false);
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState(false);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);

  const handleOnClick_Guardar = async (e) => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);
      
      /*
      const JSON = await function_VEN_Pedidos_Generar_JSON(idPedidoAsignado, 1, idTipoDocVenta,
        FormateoFechaPara_yyyyMMdd_HHmmss(fecha), idCliente,
        datosDocumento.numeroFantasia, datosDocumento.codigoPuntoVenta, datosDocumento.numero, "",
        codigoMoneda, cotizacion, 0, 0,
        datosConceptoObservaciones.concepto, datosConceptoObservaciones.observaciones, conEnvio,
        FormateoFechaPara_yyyyMMdd_HHmmss(fechaCompromiso), codigoCondicionVenta, false, 0, false, "", "", null, null,
        codigoMonedaReferente, false, false, false, false,
        localStorage.getItem("IdPersona"), null, codigoLocacion, 0, "", "", 0, 0, datosDetalle, [], [])

      if (props.Codigo.Codigo === "--NUEVO--") {

        const PedidoCreado = await function_VEN_Pedidos_Cabecera_Insertar(JSON, false)

        alert("Se ha generado el Pedido de Venta ID: " + PedidoCreado.data.codigoGenerado)
      } else {

        const PedidoCreado = await function_VEN_Pedidos_Cabecera_Modificar(JSON, false)

        alert("Se ha modificado el Pedido de Venta ID: " + idPedidoAsignado)
      }

      window.location.reload()
      */
    } catch (error) {
      alert(error)
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        /*
        const datosModificadores = await ObtieneParametros();
        setGlobalUsaArticulosConPresentacion(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion))
        setGlobalUsaArticulosConTamano(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano))
        setGlobalUsaArticulosConUnidadDeMedida(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida))
        setCodigoMoneda(datosModificadores.GlobalMonedaBase)
        setCodigoMonedaReferente(datosModificadores.GlobalMonedaReferente)

        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

        } else {
          setTituloBoton("ACTUALIZAR ID " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR ID " + props.Codigo.Codigo)

          setIdPedidoAsignado(props.Codigo.Codigo)

          const datosDocumento = await function_VEN_Pedidos_Cabecera_Leer(props.Codigo.Codigo)

          setIdCliente(datosDocumento.data.IdCliente)
          setCodigoMoneda(datosDocumento.data.CodigoMoneda)
          setCotizacion(datosDocumento.data.Cotizacion)
          setCodigoCondicionVenta(datosDocumento.data.CodigoCondicionVenta)
          setFecha(new Date(datosDocumento.data.Fecha))
          setFechaCompromiso(new Date(datosDocumento.data.FechaCompromiso))
          setCodigoLocacion(datosDocumento.data.CodigoLocacion)
          setCodigoMoneda(datosDocumento.data.CodigoMoneda)
          setCodigoMonedaReferente(datosDocumento.data.CodigoMonedaReferente)
          setConEnvio(datosDocumento.data.ConEnvio)
          setIdTipoDocVenta(datosDocumento.data.IdTipoDocVenta)
          setCotizacion(datosDocumento.data.Cotizacion)
          setDatosConceptoObservaciones({
            concepto: datosDocumento.data.Concepto,
            observaciones: datosDocumento.data.Observaciones
          })

          if (datosDocumento.data.Detalles && datosDocumento.data.Detalles.length > 0) {
            const idMasAlto = datosDocumento.data.Detalles.reduce((maxId, detalle) => {
              return detalle.IdItem > maxId ? detalle.IdItem : maxId;
            }, 0);

            const nuevosDatosDetalle = datosDocumento.data.Detalles.map(detalle => {
              return {
                ...detalle,
                id: detalle.IdItem,
                ImporteBonificaciones: detalle.ImporteDescuentos,
                ImporteNetoTotal: detalle.ImporteNeto * detalle.Cantidad,
                ImporteDescuentosTotal: detalle.ImporteDescuentos * detalle.Cantidad,
                ImporteRecargosTotal: detalle.ImporteRacargos * detalle.Cantidad,
                ImporteIVATotal: detalle.ImporteIVA * detalle.Cantidad,
                ImporteImpuestosInternosTotal: detalle.ImporteImpuestosInternos * detalle.Cantidad
              };
            });

            setDatosDetalle(nuevosDatosDetalle);

            setIdItemMasAlto(idMasAlto + 1)
          }
        }

        setLoading(false);
        */
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div>
          <div className="LV-GroupBox-div" style={{ display: 'flex', marginLeft: '6px', marginRight: '6px', marginBottom: '7px', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>
            Descripción
            <TextBox value={descripcion} onValueChanged={(e) => setDescripcion(e.value)} />

            Fecha Desde
            <DateBox displayFormat="dd/MM/yyyy" value={fechaDesde} onValueChanged={(e) => setFechaDesde(e.value)} width={120} />

            <CheckBox text="Sin Fin" />
            Fecha Hasta
            <DateBox displayFormat="dd/MM/yyyy" value={fechaHasta} onValueChanged={(e) => setFechaHasta(e.value)} width={120} />

            Moneda
            <ComboAbmConMonedas onValueChanged={(e) => setCodigoMoneda(e.value)} value={codigoMoneda} />
          </div>
          <div className="LV-GroupBox-div" style={{ display: 'flex', marginLeft: '6px', marginRight: '6px', marginBottom: '7px', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>
          </div>

          <div style={{ display: 'flex', marginBottom: '5px', marginTop: '20px', alignItems: 'center', justifyContent: 'center', gap: '50px' }}>
            <LVButtonAccion
              Disabled={cierreEnProceso} Texto={TituloBoton} onClick={handleOnClick_Guardar} />
          </div >
        </div >
      )}
    </>
  )
}

export default COM_ListasPrecios;